import http from 'hub-http/clients/apiClient';
const ZORSE_BASE_URL = 'zorse/v2';
const HELP_DESK_INTEGRATION_BASE_URL = 'helpdesk-integration/v1';
export const getToolLinksByThreadId = threadId => {
  return http.get(`${ZORSE_BASE_URL}/tools/links/${threadId}`);
};
export const getToolLinksByTicketId = ticketId => {
  return http.get(`${HELP_DESK_INTEGRATION_BASE_URL}/tickets/${ticketId}/links`);
};